import { render, staticRenderFns } from "./CarouselPopUp.vue?vue&type=template&id=6c2567c1&scoped=true&"
import script from "./CarouselPopUp.vue?vue&type=script&lang=js&"
export * from "./CarouselPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPopUp.vue?vue&type=style&index=0&id=6c2567c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2567c1",
  null
  
)

export default component.exports